import './IconDDAPause.css';
import React from 'react';
var IconDDAPause = function IconDDAPause(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 48 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 48 : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className, " ").concat(styles),
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 38H20V10H12V38ZM28 10V38H36V10H28Z"
  }));
};
var styles = "sigyamx";
export default IconDDAPause;